import styled from "styled-components";

const Container = styled.div`
  padding: 30px 20px;
`;

export default Container;
